import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CompanyRealtorStore } from './types';

const initialState: CompanyRealtorStore = {
  totalElements: 0,
  totalPages: 0,
  openRealtorDrawer: {
    realtorId: null,
    visible: false,
    name: ''
  }
};

const companyRealtorSlice = createSlice({
  initialState,
  name: 'company-realtor-slice',
  reducers: {
    setCompanyRealtorTotalItems: (state, actions: PayloadAction<{ totalElements: number; totalPages: number }>) => {
      state.totalElements = actions.payload.totalElements;
      state.totalPages = actions.payload.totalPages;
    },
    setOpenRealtorDrawer: (
      state,
      actions: PayloadAction<{ visible: boolean; realtorId: number | null; name: string }>
    ) => {
      const { realtorId, visible, name } = actions.payload;

      state.openRealtorDrawer.realtorId = realtorId;
      state.openRealtorDrawer.visible = visible;
      state.openRealtorDrawer.name = name;
    }
  }
});

export const companyRealtorReducer = companyRealtorSlice.reducer;
export const { setCompanyRealtorTotalItems, setOpenRealtorDrawer } = companyRealtorSlice.actions;
